<template>
  <!-- <Input v-model="result" @on-focus='aaa'
    ><template #append>
      <Button>更多</Button>
    </template>
  </Input> -->
  <ly-group>
    <ly-item
      v-for="(x, index) in dataList"
      :key="index"
      
      >{{ x[keyw]
      }}<Icon @click="dataList.splice(index, 1)" type="ios-backspace-outline"
    /></ly-item>
    <Button @click='aaa'>添加</Button>
  </ly-group>
</template>
<script>
export default {
  props: ["arr","keyw"],
  data() {
    return {
      result: "",
      dataList:[]
    };
  },
  methods: {
    aaa() {
      this.$emit("on-click");
    },
    sdhou() {
      var m = [1111, 2222, 3333, 4444, 5555, 6666];
      var s = 2;
      var length = s < m.length ? s : m.length;
      if (1) {
        this.result = "总共" + m.length + "个";
      }
    },
  },
  mounted() {
    this.dataList = this.arr;
    console.log(this.arr);
  },
  model:{
    prop: "arr",
  },
  watch: {
    arr(v) {
      this.dataList = v;
      console.log(v);
    },
  },
};
</script>


// WEBPACK FOOTER //
// ../common/src/components/alotItem.vue